import api from "./api";
import endpoints from "./endpoints";

export default {
  getAdvancedSettings: async function (catalogMappingTargetId) {
    const response = await api.get(endpoints.autoMapping.getAdvancedSettings, {
      params: { catalogMappingTargetId: catalogMappingTargetId }
    });
    return response.data;
  },
  saveAdvancedSettings: async function (advancedAutoMappingSettings) {
    return await api.post(endpoints.autoMapping.saveAdvancedSettings, advancedAutoMappingSettings, {}).then((x) => Promise.resolve(x.data));
  },
  saveAutoMappingProfile: async function (autoMappingProfile) {
    return await api.post(endpoints.autoMapping.saveAutoMappingProfile, autoMappingProfile, {}).then((x) => Promise.resolve(x.data));
  },
  deleteProfile: async function (profileId) {
    const response = await api.post(endpoints.autoMapping.deleteProfile, {}, { params: { profileId } });
    return response.data;
  },
  getAutoMappingScriptDetails: async function (targetSystem) {
    const response = await api.get(endpoints.autoMapping.getAutoMappingScriptDetails, { params: { targetSystem: targetSystem } });
    return response.data;
  },
  getAutoMappingProfile: async function (profileId) {
    const response = await api.get(endpoints.autoMapping.getAutoMappingProfile, { params: { profileId: profileId } });
    return response.data;
  },
  execute: async function (mappingGeneratorSettings, language, connectionId) {
    return await api
      .post(endpoints.autoMapping.execute, mappingGeneratorSettings, {
        params: { language, connectionId }
      })
      .then((x) => Promise.resolve(x.data));
  },
  getMappingScriptNames: async function () {
    const response = await api.get(endpoints.autoMapping.getMappingScriptNames, {
      params: {}
    });
    return response.data;
  },
  getMappingExpression: async function (sourceFields, mappingScriptName) {
    return await api
      .post(endpoints.autoMapping.getMappingExpression, sourceFields, {
        params: { mappingScriptName }
      })
      .then((x) => Promise.resolve(x.data));
  }
};
